import React from "react";

export default function AboutUs() {
  return (
    <section className="" id="AboutUs">
      <div className="container mt-36 px-4">
        <div
          className="flex flex-col items-center relative w-full bg-lighterGray rounded-2xl border border-gray-800 text-white z-20 pb-[30px] md:pb-[70px]" // حذف overflow-hidden
          style={{ direction: "rtl" }}
        >
          <div className=" flex flex-col items-center pt-10 md:text-4xl text-xl text-white font-DanaDemiBold px-4">
            <div className="md:leading-[70px] leading-[40px] text-center z-30">
              <h2
                style={{
                  textShadow: "0 0 60px rgba(212,254,0,0.5)",
                  fontWeight: "700",
                }}
              >
                بستری آنلاین برای طرفداران{" "}
              </h2>

              <span
                className="text-[#D4FE00] inline-flex flex-col gap-y-0 md:gap-y-2 items-center"
                style={{
                  textShadow: "0 0 60px rgba(212,254,0,0.5)",
                  fontWeight: "700",
                }}
              >
                فارسی زبان ماین کرفت{" "}
                <svg
                  width={
                    typeof window !== "undefined" && window.innerWidth < 400
                      ? "100px"
                      : "216px"
                  }
                  height="24"
                  viewBox="0 0 216 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2 15L58 3L46 20.5C69.6667 14.6667 169.9 3 213.5 3"
                    stroke="url(#paint0_linear_40_190)"
                    stroke-width="4"
                    stroke-linecap="round"
                  ></path>
                  <defs>
                    <linearGradient
                      id="paint0_linear_40_190"
                      x1="2.5"
                      y1="12"
                      x2="160.5"
                      y2="2.99993"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="#D4FE00"></stop>
                      <stop offset="1" stop-color="#D4FE00"></stop>
                    </linearGradient>
                  </defs>
                </svg>
              </span>
            </div>

            <p className="md:mt-[35px] mt-[20px]  max-w-[822px] leading-7.5 text-base/[30px] md:text-lg text-[#828B97] z-50 md:text-center text-justify">
              زمانی که ماین کرافت در ایران طرفدار های زیادی مانند بقیه کشورهای
              دنیا پیدا کرد , نیاز کاربرهای ماین کرافت به بازی کردن در سرورهای
              ماینکرفت نیز پر رنگ شد و در ادامۀ این نیاز افرادی برای ساخت سرور
              ماینکرافت دست به کار شدند و کاربرهایی را نیز جذب کردند اما به دلیل
              نداشتن مهارت و انگیزۀ کافی , نتوانستند سرور خوبی برای بازی کردن
              ماین کرافت در اختیار کاربرهای ایرانی قرار دهند، تا اینکه در 4 بهمن
              سال 1398 سرور تیرکس ماین فعالیت خود را شروع کرد
            </p>
          </div>
          <img
            src="./images/king.png"
            alt=""
            className="absolute left-0 bottom-0 md:block hidden z-10"
            style={{ top: "auto" }}
          />
          <img
            src="./images/crown.png"
            alt=""
            className="absolute z-50 left-[50%] md:-top-[120px] -top-[60px] -translate-x-1/2 md:w-auto md:h-auto w-[90px] h-[90px]"
          />
          <img
            src="./images/king.png"
            alt=""
            className="absolute right-0 bottom-0  md:block hidden z-10"
            style={{ transform: "scaleX(-1)" }}
          />
        </div>
      </div>
    </section>
  );
}
